import React, { useMemo } from 'react';
import Icon from '../../../components/AppIcon';

const PackageQuickStats = ({ packages }) => {
  const stats = React.useMemo(() => {
    const total = packages.length;
    const active = packages.filter(p => p.status === 'active').length;
    const draft = packages.filter(p => p.status === 'draft').length;
    const suspended = packages.filter(p => p.status === 'suspended').length;
    const archived = packages.filter(p => p.status === 'archived').length;
    
    const totalBookings = packages.reduce((sum, p) => sum + (p.bookings || 0), 0);
    const totalRevenue = packages.reduce((sum, p) => {
      const price = parseFloat(p.price?.replace(/[₹,]/g, '') || 0);
      return sum + (price * (p.bookings || 0));
    }, 0);

    const avgRating = packages.reduce((sum, p) => sum + (p.rating || 0), 0) / total || 0;

    return {
      total,
      active,
      draft,
      suspended,
      archived,
      totalBookings,
      totalRevenue,
      avgRating
    };
  }, [packages]);

  const statCards = [
    {
      label: 'Total Packages',
      value: stats.total,
      icon: 'Package',
      color: 'text-foreground',
      bg: 'bg-muted/30'
    },
    {
      label: 'Active Packages',
      value: stats.active,
      icon: 'CheckCircle',
      color: 'text-success',
      bg: 'bg-success/10'
    },
    {
      label: 'Draft Packages',
      value: stats.draft,
      icon: 'Edit',
      color: 'text-muted-foreground',
      bg: 'bg-muted/30'
    },
    {
      label: 'Total Bookings',
      value: stats.totalBookings,
      icon: 'Users',
      color: 'text-primary',
      bg: 'bg-primary/10'
    },
    {
      label: 'Total Revenue',
      value: `₹${(stats.totalRevenue / 100000).toFixed(1)}L`,
      icon: 'DollarSign',
      color: 'text-secondary',
      bg: 'bg-secondary/10'
    },
    {
      label: 'Average Rating',
      value: stats.avgRating.toFixed(1),
      icon: 'Star',
      color: 'text-accent',
      bg: 'bg-accent/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
      {statCards.map((stat, index) => (
        <div key={index} className={`${stat.bg} rounded-lg p-4`}>
          <div className="flex items-center justify-between">
            <div>
              <div className="text-2xl font-bold text-foreground">{stat.value}</div>
              <div className="text-xs text-muted-foreground mt-1">{stat.label}</div>
            </div>
            <div className={`p-2 rounded-lg bg-card ${stat.color}`}>
              <Icon name={stat.icon} size={20} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PackageQuickStats;